import { render, staticRenderFns } from "./ReferenceTable.vue?vue&type=template&id=d28cb77e&scoped=true&"
import script from "./ReferenceTable.vue?vue&type=script&lang=js&"
export * from "./ReferenceTable.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTable.vue?vue&type=style&index=0&id=d28cb77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28cb77e",
  null
  
)

export default component.exports